.content {
  /* padding: var(--mantine-spacing-md); */
  /* height: 100cqh; */
  /* padding: var(--mantine-spacing-md); */
  /* width: 80%; */
  /* margin-left: auto; */
  /* padding: var(--mantine-spacing-md); */
  /* height: 100cqh; */
  /* padding: var(--mantine-spacing-md); */
  overflow: auto;
}

.chat {
  display: contents;
  /* display: grid; */
  /* width: 100%; */
  /* height: 100%; */
}
